import React from 'react';
import { Provider } from 'react-contextual';
import { user } from '../../../data/stores';
import { program } from '../../../store';

const SiteData = ({
	store, children,
}) => (
	<Provider {...user} {...program} {...store}>
		{children}
	</Provider>
);

export default SiteData;
